import {DOCUMENT_STATE} from 'front-onceforall-core/dist/utils/documents';

export const DOCUMENT_STATES_TO_PROCESS = [
  DOCUMENT_STATE.AWAITING_SIGNATURE,
  DOCUMENT_STATE.EXPIRED,
  DOCUMENT_STATE.MISSING,
  DOCUMENT_STATE.REJECTED
];
